// @ts-check

import {z} from "zod"

export const genDefaultString = (defaultStr = "") =>
  z
    .string()
    .nullish()
    .transform(v => v ?? defaultStr)
    .default(defaultStr)

export const genDefaultBoolean = (bool = false) =>
  z
    .boolean()
    .nullish()
    .transform(v => v ?? bool)
    .default(bool)

export const stringToJSDate = z
  .string()
  .transform(d => (typeof d === "string" ? new Date(d) : d))
